// Dynamically adjust the width of the select based on the selected option
function adjustSortSelectWidth() {
  var select = document.querySelector('.collection-sort-select');
  if (!select) return;

  // Create a temporary span to measure text width
  var tempSpan = document.createElement('span');
  tempSpan.style.visibility = 'hidden';
  tempSpan.style.position = 'fixed';
  tempSpan.style.whiteSpace = 'pre';
  tempSpan.style.fontSize = window.getComputedStyle(select).fontSize;
  tempSpan.style.fontFamily = window.getComputedStyle(select).fontFamily;
  tempSpan.style.fontWeight = window.getComputedStyle(select).fontWeight;
  tempSpan.style.letterSpacing = window.getComputedStyle(select).letterSpacing;

  // Get the selected option's text
  var selectedOption = select.options[select.selectedIndex];
  tempSpan.textContent = selectedOption.text;
  document.body.appendChild(tempSpan);

  // Add extra space for the arrow and padding
  var width = tempSpan.offsetWidth + 36;
  select.style.width = width + 'px';
  document.body.removeChild(tempSpan);
}

document.addEventListener('DOMContentLoaded', function() {
  adjustSortSelectWidth();
  var select = document.querySelector('.collection-sort-select');
  if (select) {
    select.addEventListener('change', adjustSortSelectWidth);
  }
});
